module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('vmap', {
    attrs: {
      "position": _vm.position,
      "zoom": _vm.zoom
    },
    on: {
      "zoom": _vm.onZoom,
      "move": _vm.onMove
    }
  }, [_c('vmap-tile-layer', {
    attrs: {
      "url": "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      "attribution": "&copy; <a href=&#34;http://osm.org/copyright&#34;>OpenStreetMap</a> contributors uga uga"
    }
  }), _vm._v(" "), _vm._l((_vm.markers), function(markerPosition) {
    return _c('vmap-marker', {
      attrs: {
        "position": markerPosition
      }
    })
  }), _vm._v(" "), _c('vmap-layer-group', [_c('vmap-geo-json', {
    attrs: {
      "data": _vm.geoJson,
      "feature-style": _vm.geoJsonStyle
    }
  }), _vm._v(" "), _c('vmap-circle', {
    attrs: {
      "position": {
        lat: 49.614,
        lng: 6.084
      },
      "radius": 1000,
      "stroke": true,
      "color": "#990"
    }
  })]), _vm._v(" "), _c('vmap-rectangle', {
    attrs: {
      "bounds": [{
        lat: 49.614,
        lng: 6.084
      }, {
        lat: 49.62,
        lng: 6.118
      }]
    }
  }), _vm._v(" "), _c('vmap-polyline', {
    attrs: {
      "latlngs": [{
        lat: 49.614,
        lng: 6.084
      }, {
        lat: 49.62,
        lng: 6.118
      }]
    }
  })], true), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Map")]), _vm._v(" "), _c('div', [_vm._v("\n      Latitude: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lat),
      expression: "lat"
    }],
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": _vm._s(_vm.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lat = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n      Longitude: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.lng),
      expression: "lng"
    }],
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": _vm._s(_vm.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.lng = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addMarkerAtMapPosition
    }
  }, [_vm._v("Add Marker")])]), _vm._v(" "), _c('div', [_vm._v("\n      Zoom:\n      "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.zoom),
      expression: "zoom"
    }],
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": _vm._s(_vm.zoom)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.zoom = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Markers")]), _vm._v(" "), _vm._l((_vm.markers), function(marker, index) {
    return _c('div', [_vm._v("\n      Latitude: "), _c('input', {
      attrs: {
        "type": "number",
        "step": "any"
      },
      domProps: {
        "value": marker.lat
      },
      on: {
        "input": function($event) {
          _vm.updateMarkerLat(index, $event)
        }
      }
    }), _vm._v("\n      Longitude: "), _c('input', {
      attrs: {
        "type": "number",
        "step": "any"
      },
      domProps: {
        "value": marker.lng
      },
      on: {
        "input": function($event) {
          _vm.updateMarkerLng(index, $event)
        }
      }
    }), _vm._v(" "), _c('button', {
      on: {
        "click": function($event) {
          _vm.removeMarker(index)
        }
      }
    }, [_vm._v("Remove")])])
  }), _vm._v(" "), _c('div', [_vm._v("\n      Latitude: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMarker.lat),
      expression: "newMarker.lat"
    }],
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": _vm._s(_vm.newMarker.lat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMarker.lat = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v("\n      Longitude: "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newMarker.lng),
      expression: "newMarker.lng"
    }],
    attrs: {
      "type": "number",
      "step": "any"
    },
    domProps: {
      "value": _vm._s(_vm.newMarker.lng)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newMarker.lng = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.addMarker
    }
  }, [_vm._v("Add")])])], true)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-574e109a!./~/vue-loader/lib/selector.js?type=template&index=0!./demo/App.vue
// module id = 98
// module chunks = 2